import { render, staticRenderFns } from "./init_tem.vue?vue&type=template&id=f2c57f74&scoped=true&"
import script from "./init_tem.vue?vue&type=script&lang=js&"
export * from "./init_tem.vue?vue&type=script&lang=js&"
import style0 from "./init_tem.vue?vue&type=style&index=0&id=f2c57f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c57f74",
  null
  
)

export default component.exports